<template>
  <a-card :bordered="false">
    <s-table
      size="default"
      ref="table"
      :columns="columns"
      :data="loadData"
      bordered
      :scroll="{ x: 1800 }"
    >
      <span slot="action" slot-scope="text, record">
        <a v-if="editEnabel" @click="handleEdit(record)">编辑</a>
      </span>
    </s-table>
    <backlog-modal ref="modal" @ok="handleOk"/>
  </a-card>
</template>
<script>

  import { STable } from '@/components'
  import { pendingMatterList } from '@/api/basicdatas/Backlog'
  import BacklogModal from './modules/BacklogModal.vue'
  import { checkPermission } from '@/utils/permissions'

  export default {
    name: 'Backlog',
    components: {
      STable,
      BacklogModal,
    },
    data () {
      return {
        form: this.$form.createForm(this),
        mdl: {},
        // 高级搜索 展开/关闭
        advanced: false,
        // 表头
        columns: [
          {
            title: '序号',
            dataIndex: 'rowNum',
            align: 'center',
          }, {
            title: '操作',
            width:60,
            dataIndex: 'action',
            scopedSlots: { customRender: 'action'},
          }, {
            title: '待办事项名称',
            dataIndex: 'matterName',
            align: 'center',
          }, {
            title: '待办事项类型',
            dataIndex: 'matterTypeName',
            align: 'center',
          }, {
            title: '一级接收人',
            dataIndex: 'firstReceive',
          }, {
            title: '二级接收人',
            dataIndex: 'secondReceive',
          }, {
            title: '一级抄送人',
            dataIndex: 'firstCopyTo',
          }, {
            title: '二级抄送人',
            dataIndex: 'secondCopyTo',
          }, {
            title: '超时时间',
            dataIndex: 'timeoutPeriod',
            align: 'center',
          }, {
            title: '超时结束时间',
            dataIndex: 'timeoutEndTime',
            align: 'center',
          }, {
            title: '处理跳转页面',
            dataIndex: 'jumpUrlName',
            align: 'center',
          }, {
            title: '发起人',
            dataIndex: 'initiator',
          }
        ],
        data:[],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          return pendingMatterList(Object.assign(parameter, this.queryParam))
        },
        addEnable: checkPermission('enterprise:channel:add'),
        editEnabel: checkPermission('enterprise:channel:edit'),
        removeEnable: checkPermission('enterprise:channel:remove')
      }
    },
    filters: {},
    created () {
    },
    methods: {
      handleEdit (record) {
        console.log(record)
        this.$refs.modal.edit(record)
      },
      handleOk () {
        this.$refs.table.refresh()
        console.log('handleSaveOk')
      },
    },
    watch: {
      /*
          'selectedRows': function (selectedRows) {
            this.needTotalList = this.needTotalList.map(item => {
              return {
                ...item,
                total: selectedRows.reduce( (sum, val) => {
                  return sum + val[item.dataIndex]
                }, 0)
              }
            })
          }
          */
    }
  }
</script>

<style scoped>
  .twobtn{
    background-color: #409EFF;
    color: white;
    width: 110px;
    font-size: 15px;
  }
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td {  white-space: nowrap;padding: 4px 16px;}
</style>
